import SaleService from '../../../services/sale';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { Popups } from 'commons/components/popups/popups';
import {
  BEGIN_FETCH,
  FETCH_COMPLETED,
  DownloadAction,
  SET_CREDIT_NOTE,
  SET_INVOICE,
} from './types';
import { InvoiceStamp, InvoiceItem, Page } from 'types/type';
import InvoiceService from 'services/invoice';

const saleService = new SaleService();
const invoiceService = new InvoiceService();

const startFetch = (): DownloadAction => {
  return { type: BEGIN_FETCH };
};

const endFetch = (): DownloadAction => {
  return { type: FETCH_COMPLETED };
};

export const getCreditNotes = (
  id: string,
  page: number,
  size: number,
): ThunkAction<Promise<void>, unknown, unknown, AnyAction> => {
  return async (dispatch): Promise<void> => {
    try {
      dispatch(startFetch());
      const creditNotesPage: Page<InvoiceStamp> =
        await saleService.getCreditNotesByLote(id, page, size);
      dispatch({ type: SET_CREDIT_NOTE, creditNotesPage: creditNotesPage });
      dispatch(endFetch());
    } catch (err) {
      dispatch(endFetch());
      Popups.notifyError('Error al obtener notas de crédito');
    }
  };
};

export const getInvoiceInfo = (
  id: string,
): ThunkAction<Promise<void>, unknown, unknown, AnyAction> => {
  return async (dispatch): Promise<void> => {
    try {
      const invoiceInfo: InvoiceItem = await invoiceService.getInvoiceById(id);
      dispatch({ type: SET_INVOICE, invoiceInfo });
    } catch (err) {
      Popups.notifyError('Error al obtener datos de la factura');
    }
  };
};
